import { Box, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import ThemeChangeModal from "../components/Modals/ThemeChangeModal";
import { useQuickLinksItems } from "../context/QuickLinksContext";
import MobileSidebar from "../components/MobileSidebar";

const Layout = ({ children }) => {
  const theme = useTheme();

  const [themeChange, setThemeChange] = useState(false);

  const { setSelectedTab } = useQuickLinksItems();

  const [openSidebar, setOpenSidebar] = useState(false);

  useEffect(() => {
    const handleBackButton = (event) => {
      event.preventDefault();
      setSelectedTab("home");
    };

    window.addEventListener("popstate", handleBackButton);
    window.addEventListener("hashchange", handleBackButton);

    return () => {
      window.removeEventListener("popstate", handleBackButton);
      window.removeEventListener("hashchange", handleBackButton);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        minHeight: "100vh",
        background: theme.palette.background.gradient,
        backgroundColor: theme.palette.background.default,
        position: "relative",
        padding: "0 16px",
      }}
    >
      <Navbar
        setThemeChange={setThemeChange}
        setOpenSidebar={setOpenSidebar}
        openSidebar={openSidebar}
      />
      <MobileSidebar
        open={openSidebar}
        toggleSidebar={() => setOpenSidebar(!openSidebar)}
      />
      <ThemeChangeModal
        open={themeChange}
        handleClose={() => setThemeChange(false)}
      />
      {children}
    </Box>
  );
};

export default Layout;
